export default __webpack_public_path__ + "static/media/pg-33.4130836e.jpg";